import { isPasswordRecoveryPath } from './_helpers/password-recovery';
import { isDemoEntryPath } from './_helpers/demo-entry';
import { Component } from '@angular/core';
import moment from 'moment';
import IHelpContent from './_interfaces/IHelpContent';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from './_services/session/session.service';
import { Router, RouterModule } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { LoadingComponent } from './components/loading/loading.component';
import { LayoutComponent } from './components/layout/layout.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TabsModule } from 'primeng/tabs';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    LoadingComponent,
    LayoutComponent,
    TabsModule,
    ConfirmDialogModule,
    ToastModule,
    RouterModule,
  ],
})
export class AppComponent {
  title = 'crm-front';
  isAuthenticated = false;
  help: {
    display: boolean;
    content: IHelpContent;
  } = {
    display: false,
    content: {
      content: undefined,
      footer: undefined,
      header: undefined,
    },
  };

  constructor(
    private translateService: TranslateService,
    private config: PrimeNG,
    private session: SessionService,
    private router: Router
  ) {}

  ngOnInit() {
    const lang = this.session.normalizeLanguage(localStorage.getItem('language'));
    this.session.setLanguage(lang);

    this.session.getUser$().subscribe((user) => {
      this.isAuthenticated = !!user;
      if (!user && this.router.url !== '/' && !isPasswordRecoveryPath(this.router.url) && !isDemoEntryPath(this.router.url)) {
        return this.router.navigate(['']);
      }
      return undefined;
    });

    this.setTranslations();

    this.translateService.onLangChange.subscribe(() => {
      this.setTranslations();
    });
  }

  private setTranslations() {
    moment.updateLocale(this.translateService.currentLang, {
      week: {
        dow: 1,
        doy: 0,
      },
    });

    this.translateService
      .get('PRIMENG')
      .subscribe((res) => this.config.setTranslation(res));
  }
}
